import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col lg:flex-row">
      {/* Left - Image */}
      <div className="lg:w-1/2 h-[350px] md:h-[500px] lg:h-auto relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20lifestyle%20flatlay%20scene%20with%20ceramic%20coffee%20mug%20beside%20open%20notebook%20and%20neatly%20folded%20cashmere%20scarf%20in%20soft%20terracotta%20tone%20on%20light%20oak%20wooden%20table%20surface%2C%20scattered%20dried%20eucalyptus%20leaves%2C%20soft%20natural%20morning%20sunlight%20streaming%20through%20sheer%20linen%20curtains%20creating%20gentle%20warm%20glow%2C%20cozy%20editorial%20still%20life%20photography%20with%20rich%20textures%20and%20organic%20composition%2C%20serene%20warm%20neutral%20aesthetic&width=1200&height=900&seq=cta-split-v2-july&orientation=portrait"
          alt="Kakobuy produkty"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Right - CTA */}
      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 lg:px-16 py-14 md:py-20">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 leading-tight">
            {t('cta_title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
            {t('cta_subtitle')}
          </p>
          <p className="text-xs md:text-sm text-foreground-400 leading-relaxed mb-8">
            {t('cta_desc')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-900 text-background-50 font-semibold text-sm rounded-lg hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('btn_buy_now')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}